(function () {
  'use strict';

  if (window.__amadaConversionEventsLoaded) return;
  window.__amadaConversionEventsLoaded = true;

  function publish(name, payload) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(name, payload || {});
    }
  }

  // ---------------------------------------------------------
  // 1. SUCCESSFUL HULK ENQUIRY
  // Fires ONLY after Hulk reports a successful submission.
  // ---------------------------------------------------------

  document.addEventListener('amada:hulk:success', function (event) {
    var detail = event.detail || {};
    var fields = detail.fields || {};

    publish('amada:enquiry_submitted', {
      lead_id:
        fields.lead_id ||
        fields.email ||
        ('hulk_' + Date.now()),

      form_id: detail.form || null,
      source: 'hulk_form',
      page_url: window.location.href,
      product: fields.piece_title || null,
      variant: fields.piece_variant || null,
      sku: fields.piece_sku || null
    });
  });


  // ---------------------------------------------------------
  // 2. NORMAL SHOPIFY CONTACT FORM SUCCESS
  // Shopify renders this element only after a real success.
  // ---------------------------------------------------------

  function detectShopifyContactSuccess() {
    var successNodes = document.querySelectorAll(
      '.amada-booking__success'
    );

    successNodes.forEach(function (node) {
      if (node.dataset.amadaTracked === 'true') return;

      node.dataset.amadaTracked = 'true';

      publish('amada:enquiry_submitted', {
        lead_id: 'contact_' + Date.now(),
        source: 'shopify_contact_form',
        page_url: window.location.href
      });
    });
  }

  detectShopifyContactSuccess();

  var contactObserver = new MutationObserver(function () {
    detectShopifyContactSuccess();
  });

  contactObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });


  // ---------------------------------------------------------
  // 3. CALENDLY SUCCESSFUL APPOINTMENT
  // Fires ONLY after Calendly confirms event_scheduled.
  // ---------------------------------------------------------

  window.addEventListener('message', function (event) {
    if (
      !event.origin ||
      event.origin.indexOf('calendly.com') === -1
    ) {
      return;
    }

    var data = event.data;

    if (
      !data ||
      data.event !== 'calendly.event_scheduled'
    ) {
      return;
    }

    var inviteeUri =
      data.payload &&
      data.payload.invitee &&
      data.payload.invitee.uri;

    var eventUri =
      data.payload &&
      data.payload.event &&
      data.payload.event.uri;

    publish('amada:appointment_booked', {
      appointment_id:
        inviteeUri ||
        eventUri ||
        ('calendly_' + Date.now()),

      source: 'calendly',
      page_url: window.location.href
    });
  });


  // ---------------------------------------------------------
  // 4. WHATSAPP CLICK
  // Intent signal only — NOT a lead conversion.
  // ---------------------------------------------------------

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href*="wa.me"], a[href*="whatsapp.com"], [data-amada-enquiry-whatsapp]'
    );

    if (!link) return;

    publish('amada:whatsapp_clicked', {
      page_url: window.location.href,
      destination: link.href || null
    });
  });


  // ---------------------------------------------------------
  // 5. EMAIL CLICK
  // Intent signal only — NOT a lead conversion.
  // ---------------------------------------------------------

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href^="mailto:"], [data-amada-enquiry-email]'
    );

    if (!link) return;

    publish('amada:email_clicked', {
      page_url: window.location.href,
      destination: link.href || null
    });
  });


  // ---------------------------------------------------------
  // 6. PHONE CLICK
  // Intent signal only.
  // ---------------------------------------------------------

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href^="tel:"]'
    );

    if (!link) return;

    publish('amada:phone_clicked', {
      page_url: window.location.href,
      destination: link.href || null
    });
  });
})();
